/**
 * VENDOR MODULES
 */
import React from 'react';

import ModernTipItem from 'features/tickets/components/ModernTipItem';
import { useTicketSlipStore } from 'features/tickets/store';

/**
 * Modern Tips Component
 *
 * Renders the tips in the modern ticket area
 */
function ModernTips() {
  const ticket_slip = useTicketSlipStore((s) => s.ticket_slip);

  const tips_list = ticket_slip.map((tip, index) => (
    <ModernTipItem {...(tip as Record<string, unknown>)} key={index} />
  ));

  return (
    <div className="modern-tips">
      {tips_list}
    </div>
  );
}

export default ModernTips;

